import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/serviceGroup/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/serviceGroup/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/serviceGroup/FETCH_FAILURE'

// Initial State
const initialState = {
  errors: [],
  loaded: false,
  loading: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadServiceGroups(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/v1/service-groups', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_GROUP_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function loadServiceGroupsV2(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/v2/service-groups', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_GROUP_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}
